import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRouter from 'react-router';
import * as ReactRouterDOM from 'react-router-dom';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';

window.axios = axios;
window.React = React;
window.ReactDOM = ReactDOM;
window.ReactRouter = ReactRouter;
window.ReactRouterDOM = ReactRouterDOM;
window.Redux = Redux;
window.ReactRedux = ReactRedux;